const features = [
  {
    icon: 'ri-arrow-down-double-line',
    title: '下拉式阅读',
    desc: '告别翻页，滚动即可连续阅读完整章节。女神漫画下拉式模式专为手机触摸屏优化，单手操作也能轻松看全集，沉浸式追漫不中断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '手机端优化',
    desc: '女神漫画下拉式页面针对移动端深度适配，加载速度快、图片高清、排版舒适，无论 iOS 还是 Android 都能获得最佳下拉式漫画阅读体验。',
  },
  {
    icon: 'ri-global-line',
    title: '韩漫日漫全覆盖',
    desc: '女神漫画网汇集热门韩漫与经典日漫，从恋爱甜漫到热血奇幻，下拉式免费全集持续更新，一站式满足你的多元追漫口味。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费全集无广告',
    desc: '女神漫画下拉式平台坚持免费提供完整全集内容，清爽阅读无干扰弹窗，让你专注于漫画本身，享受纯净的下拉式阅读之旅。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">平台特色</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式为你打造的专属阅读优势</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, i) => (
            <div
              key={i}
              className="p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}